<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tEnGY/tc-custom/9781615810079.jpg?1724535395933" alt="This image is the cover for the book Flight"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Flight
      </h1>
      <p class="bookDescription body article font2">
        <p>Torn from his home and family by slavers, Varan escapes the brutality of the mines only to struggle for existence in the hellish desert of an alien world. When he stumbles across an injured, winged being, he can barely believe the beautiful stranger isn't a hallucination conjured by his loneliness. Hiding from the slavers as they learn to communicate, Varan teaches Tvri'il how to survive, and Tvri'il teaches Varan how to love again. But can that love endure once the secrets of the slave planet—and of Tvri'il himself—are revealed?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nicki Bennett
      </h2>
      
      <p class="authorDescription body article"><P>Growing up in Chicago, Nicki Bennett spent every Saturday at the central library, losing herself in the world of books. A voracious reader, she eventually found it difficult to find enough of the kind of stories she liked to read and decided to start writing them herself.</P><P>Facebook: www.facebook.com/100011754789784</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c8c4823